<template>
  <div class="box aaaaa">
    <div class="jbxx bbbbb">
      <div class="jbtop">
        <div class="icon"></div>
        <div class="tit">会员等级配置</div>
        <div></div>
      </div>
      <el-form class="jbxx-form" ref="form" v-for="(item, index) in vipList" :key="index" :model="item"
               label-width="180px">
<!--        <el-row>-->
<!--          <el-col :span="8" style="display: flex">-->
<!--            <el-form-item :label="'等级' + (index + 1)">-->
<!--              <el-input v-model="item.vipLevel"><template slot="append">级</template></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->
        <el-row>
          <el-col :span="8">
            <el-form-item label="VIP年卡充值">
              <el-input v-model="item.yearPrice"><template slot="append">元</template></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="VIP月卡充值">
              <el-input v-model="item.monthPrice"><template slot="append">元</template></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="VIP半年卡充值">
              <el-input v-model="item.halfYearPrice"><template slot="append">元</template></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" style="display: flex">
            <el-form-item label="VIP年卡兑换">
              <el-input v-model="item.yearScore"><template slot="append">积分</template></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="display: flex">
            <el-form-item label="VIP月卡兑换">
              <el-input v-model="item.monthScore"><template slot="append">积分</template></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="display: flex">
            <el-form-item label="VIP半年卡兑换">
              <el-input v-model="item.halfYearScore"><template slot="append">积分</template></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="8" style="display: flex">
            <el-form-item label="VIP生日积分倍数">
              <el-input v-model="item.birthdayScoreRate"><template slot="append">倍</template></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8" style="display: flex">
            <el-form-item label="VIP下单折扣">
              <el-input v-model="item.orderDiscount"><template slot="append">折</template></el-input>
            </el-form-item>
          </el-col>
<!--          <el-col :span="8" style="display: flex">-->
<!--            <el-form-item label="生日消费满">-->
<!--              <el-input v-model="item.birthdayConsumPrice"><template slot="append">元</template></el-input>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
        </el-row>
<!--        <el-row>-->
<!--          <el-col :span="24">-->
<!--            <el-form-item label="赠品礼品">-->
<!--              <el-button type="primary" @click="showProductDialog(index, item.vipLevelConfigGifts)">选择礼品</el-button>-->
<!--              <el-table :data="item.vipLevelConfigGifts" border style="width: 100%">-->
<!--                <el-table-column label="商品照片" align="center">-->
<!--                  <template slot-scope="scope">-->
<!--                    <el-image style="width: 60px; height: 60px" :src="scope.row.skuImg"-->
<!--                              :preview-src-list="[scope.row.skuImg]">-->
<!--                      <div slot="error" class="image-slot">-->
<!--                        <i class="el-icon-picture-outline"></i>-->
<!--                      </div>-->
<!--                    </el-image>-->
<!--                  </template>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="productName" label="商品名称" width="180" align="center">-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="skuName" label="规格名称" width="180" align="center">-->
<!--                </el-table-column>-->
<!--                &lt;!&ndash; <el-table-column-->
<!--                  prop="sellPrice"-->
<!--                  label="价格"-->
<!--                  width="180"-->
<!--                  align="center"-->
<!--                >-->
<!--                </el-table-column> &ndash;&gt;-->
<!--                <el-table-column prop="stock" label="库存" align="center" width="50">-->
<!--                </el-table-column>-->

<!--                <el-table-column prop="productStatus" label="商品状态" align="center">-->
<!--                  <template slot-scope="{ row }">-->
<!--                    <el-button v-if="row.productStatus == 1" type="success" plain>进行中</el-button>-->
<!--                    <el-button v-if="row.productStatus == 2" type="warning" plain>已下架</el-button>-->
<!--                  </template>-->
<!--                </el-table-column>-->

<!--                <el-table-column label="操作" align="center">-->
<!--                  <template slot-scope="scope">-->
<!--                    <el-button type="text" @click="handleDeleteGift(scope.$index, index)">删除</el-button>-->
<!--                  </template>-->
<!--                </el-table-column>-->
<!--              </el-table>-->
<!--            </el-form-item>-->
<!--          </el-col>-->
<!--        </el-row>-->


      </el-form>
<!--      <div class="addbtn" style="text-align: left">-->
<!--        <el-button size="medium" type="primary" @click="addlevel">添加等级</el-button>-->
<!--      </div>-->
      <div class="butt" style="text-align: center">
        <el-button size="medium" type="primary" @click="onSubmit">保存</el-button>
      </div>
    </div>

    <!-- 礼品弹窗 -->
    <el-dialog title="选择礼品" :visible.sync="productDialog" center width="70%">
      <div>
        <el-row :gutter="10">
          <el-col :span="7">
            <div class="item-col">
              <span class="label">商品名称 </span>
              <div>
                <el-input v-model="queryProuctInfo.condition.productName" style="width: 100%"
                          placeholder="请输入"></el-input>
              </div>
            </div>
          </el-col>

          <el-col :span="5"><el-button type="primary" icon="el-icon-search" @click="getGiftList">查询</el-button>
            <el-button type="info" icon="el-icon-refresh" @click="restGoods">重置</el-button>
          </el-col>
        </el-row>
      </div>
      <el-table :row-key="(row) => row.productCode" ref="multipleTable1" :data="productList" border style="width: 100%"
                @selection-change="handleProductSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="productCode" label="商品编码" width="200px" align="center" />
        <el-table-column prop="skuImg" label="商品图片" align="center" width="200px">
          <template slot-scope="scope">
            <img style="height: 50px; width: 50px" :src="scope.row.skuImg" alt="" />
          </template>
        </el-table-column>
        <el-table-column prop="productName" label="商品名称" width="200px" align="center" />
        <el-table-column prop="skuName" label="规格名称" width="200px" align="center" />
        <el-table-column prop="sellPrice" label="单价" width="100px" align="center" />
        <el-table-column prop="stock" label="库存" width="100px" align="center" />
        <el-table-column prop="stock" label="商品状态" align="center">
          <template slot-scope="{ row }">
            <el-button v-if="row.productStatus == 1" type="success" plain>进行中</el-button>
            <el-button v-if="row.productStatus == 2" type="warning" plain>已下架</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @current-change="handleProuctCurrentChange" :current-page.sync="queryProuctInfo.currPage"
                       :page-size="queryProuctInfo.pageSize" layout="total, prev, pager, next, jumper"
                       :total="queryProuctInfo.count">
        </el-pagination>
      </div>
      <el-row style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        ">
        <el-button @click="productDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmProductList">确认</el-button>
      </el-row>
    </el-dialog>

    <!-- 门店弹窗 -->
    <el-dialog title="选择门店" :visible.sync="siteDialog">
      <el-table :row-key="(row) => row.siteCode" ref="multipleTable2" :data="siteList" border style="width: 100%"
                @selection-change="handleSiteSelectionChange">
        <el-table-column type="selection" width="55"> </el-table-column>
        <el-table-column prop="siteName" label="提货点名称" width="200px" align="center" />
        <el-table-column prop="linkName" label="联系人姓名" width="200px" align="center" />
        <el-table-column prop="linkPhone" label="联系人手机号" align="center" width="200px" />
        <el-table-column prop="status" label="营业状态" width="200px" align="center">
        </el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @current-change="handleSiteCurrentChange" :current-page.sync="querySiteInfo.currPage"
                       :page-size="querySiteInfo.pageSize" layout="total, prev, pager, next, jumper" :total="querySiteInfo.count">
        </el-pagination>
      </div>
      <el-row style="
          display: flex;
          align-items: center;
          justify-content: center;
          margin-top: 20px;
        ">
        <el-button @click="siteDialog = false">取消</el-button>
        <el-button type="primary" @click="confirmSiteList">确认</el-button>
      </el-row>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data () {
    return {
      productDialog: false,
      siteDialog: false,
      productList: [],
      siteList: [],
      selectProductList: [],
      selectSiteList: [],

      categoryList: [],
      queryProuctInfo: {
        count: 0,
        currPage: 1,
        pageCount: 0,
        pageSize: 5,
        condition: {
          categoryFirstCode: '',
          productName: ''
        }
      },
      querySiteInfo: {
        count: 0,
        currPage: 1,
        pageCount: 0,
        pageSize: 5,
        condition: {}
      },
      vipList: [
        {
          vipLevel: '',
          yearPrice: '',
          monthPrice: '',
          halfYearPrice: '',
          yearScore: '',
          monthScore: '',
          halfYearScore: '',
          birthdayScoreRate: '',
          orderDiscount: '',
          birthdayConsumPrice: '',
          vipLevelConfigGifts: [],
          vipLevelConfigSites: []
        }
      ],
      rowSelectFlag1: false,
      rowSelectFlag2: false
    }
  },
  async created () {
    this.getVipConfigList()
    await this.getGiftList()
    await this.getAllParentCategoryList()
    await this.getSiteList()
  },
  methods: {
    handleDeleteGift (index1, index2) {
      this.vipList[index2].vipLevelConfigGifts.splice(index1, 1)
    },
    handleDeleteSite (index1, index2) {
      this.vipList[index2].vipLevelConfigSites.splice(index1, 1)
    },
    // 获取vip配置信息
    getVipConfigList () {
      this.$http.post('/vipLevelConfig/queryListDetail', {}).then((res) => {
        if (res.data.code === 200) {
          this.vipList = res.data.data
        } else {
          this.$message({
            message: res.data.message,
            type: 'fail'
          })
        }
      })
    },
    showProductDialog (index, list) {
      this.productDialog = true
      this.currIndex = index
      this.selectData1(list)
      console.log(index, '序号')
    },
    showSiteDialog (index, list) {
      this.siteDialog = true
      // this.getSiteList();
      this.selectData2(list)
      this.currIndex = index
      console.log(index, '序号')
    },

    // 选中礼品商品
    handleProductSelectionChange (val) {
      if (this.rowSelectFlag1) return
      console.log(`Selected:`, val)
      this.selectProductList = val
    },
    selectData1 (list) { // 根据id对比获取已经选中的数据
      this.$nextTick(() => {
        this.$refs.multipleTable1.clearSelection()
        this.rowSelectFlag1 = true
        const idList = list.map((e) => e.productCode)
        console.log(list, 'idList', this.productList)
        this.selectProductList = list
        this.productList.forEach((row) => {
          if (idList.includes(row.productCode)) {
            console.log(row, 'row')
            this.$refs.multipleTable1.toggleRowSelection(row, true)
          }
        })
        this.rowSelectFlag1 = false
      })
    },
    selectData2 (list) { // 根据id对比获取已经选中的数据
      this.$nextTick(() => {
        this.$refs.multipleTable2.clearSelection()
        this.rowSelectFlag2 = true
        const idList = list.map((e) => e.siteCode)
        console.log(list, 'idList2', this.siteList)
        this.selectSiteList = list
        this.siteList.forEach((row) => {
          if (idList.includes(row.siteCode)) {
            console.log(row, 'row')
            this.$refs.multipleTable2.toggleRowSelection(row, true)
          }
        })
        this.rowSelectFlag2 = false
      })
    },
    confirmProductList () {
      this.vipList[this.currIndex].vipLevelConfigGifts = this.selectProductList
      console.log('43243543', this.vipList)
      this.productDialog = false
    },
    // 选中站点
    handleSiteSelectionChange (val) {
      if (this.rowSelectFlag2) return
      console.log(`Selected:`, val)
      this.selectSiteList = val
    },
    confirmSiteList () {
      this.vipList[this.currIndex].vipLevelConfigSites = this.selectSiteList
      console.log('43243543', this.selectSiteList)
      this.siteDialog = false
    },

    // 获取赠品列表
    async getGiftList () {
      const response = await this.$http.post(
        '/productSku/list',
        this.queryProuctInfo
      )
      console.log(response.data.data, '优惠券')
      if (response.data.code == 200) {
        this.queryProuctInfo.pageCount = response.data.data.pageCount
        this.queryProuctInfo.count = response.data.data.count
        this.productList = response.data.data.data
      }
    },
    restGoods () {
      this.queryProuctInfo.condition.productCode = ''
      this.queryProuctInfo.condition.productName = ''
      this.queryProuctInfo.currPage = 1
      this.queryProuctInfo.pageCount = 0
      this.queryProuctInfo.pageSize = 10
      this.getGiftList()
    },
    // 获取所有一级分类
    async getAllParentCategoryList () {
      this.$http
        .post('/productCategory/queryList', {
          level: 1
        })
        .then((res) => {
          if (res.data.code === 200) {
            this.categoryList = res.data.data
          }
        })
    },
    handleProuctCurrentChange (val) {
      console.log(`Current page: ${val}`)
      this.queryProuctInfo.currPage = val
      this.getGiftList()
    },
    // 获取门店列表
    async getSiteList () {
      let res = await this.$http
        .post('/memberTeamSite/list', this.querySiteInfo)
      if (res.data.code === 200) {
        this.querySiteInfo.pageCount = res.data.data.pageCount
        this.querySiteInfo.count = res.data.data.count
        this.siteList = res.data.data.data
        console.log('32132', this.siteList)
      } else {
        this.$message({
          message: res.data.message,
          type: 'fail'
        })
      }
    },
    handleSiteCurrentChange (val) {
      console.log(`Current page: ${val}`)
      this.querySiteInfo.currPage = val
      this.getSiteList()
    },

    // 添加配置项
    addlevel () {
      this.vipList.push({
        level: '',
        birMul: '',
        orderMul: '',
        briAmount: '',
        giveRiff: '',
        couponName: ''
      })
    },

    // 删除配置项
    async delLevel (index) {
      var that = this
      const confirmResult = await that
        .$confirm('确定删除吗?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        .catch((err) => err)
      if (confirmResult !== 'confirm') {
      } else {
        that.vipList.splice(index, 1)
      }
    },

    // 提交配置
    onSubmit () {

      // this.vipList[0].merchantCode = localStorage.getItem('merchantCode')

      this.$http
        .post('vipLevelConfig/update', {...this.vipList[0]})
        .then((res) => {
          if (res.data.code === 200) {
            this.$message({
              message: '配置成功',
              type: 'fail'
            })
            this.getVipConfigList()
          } else {
            this.$message({
              message: res.data.message,
              type: 'fail'
            })
          }
        })
    }
  }
}
</script>

<style lang="less" scoped>
.box {
  //background-color: #fff;
  padding-top: 20px;

  .jbxx {
    padding-right: 10px;

    .jbtop {
      height: 56px;
      background-color: #eef1f6;
      box-sizing: border-box;
      display: flex;
      align-items: center;
      padding-left: 20px;
      margin-left: 10px;
      margin-bottom: 40px;

      .icon {
        width: 6px;
        height: 19px;
        border-radius: 10px;
        background-color: #f77f1f;
        margin-right: 10px;
      }

      .tit {
        font-weight: 700;
      }
    }

    .jbxx-form {
      padding: 10px 50px 10px 0;
      margin: 10px 20px;
      border: 1px solid #eef1f6;
      position: relative;

      .delbtn {
        position: absolute;
        top: 5px;
        right: 5px;
      }
    }
  }

  .addbtn {
    margin: 10px 60px;

    .el-button {
      // font-size: 14px;
      // font-weight: bold;
    }
  }

  .butt {
    // display: flex;
    // justify-content: space-between;
    padding: 50px 0px;
  }

  .item-col {
    display: flex;
    align-items: center;
    margin-bottom: 18px;

    .label {
      margin-right: 10px;
    }
  }
}
</style>
